import React, { useState, useEffect } from "react";

const DynamicDropdown = ({ options, onSelect, text }) => {
    const [dropdown, setDropdown] = useState(false);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest(".dropdown-toggle")) {
                setDropdown(false);
            }
        };

        window.addEventListener("click", handleClickOutside);
        return () => {
            window.removeEventListener("click", handleClickOutside);
        };
    }, []);

    const handleDropdown = () => {
        setDropdown((prev) => !prev);
    };

    const handleSelectChange = (option) => {
        onSelect(option);
        setDropdown(false);
    };

    return (
        <div className="relative">
            <div
                className="dark:bg-jacarta-700 dropdown-toggle border-jacarta-100 dark:border-jacarta-600 dark:text-jacarta-300 flex items-center justify-between rounded-lg border bg-white py-3 px-3 cursor-pointer"
                onClick={handleDropdown}
            >
                <span>{text}</span>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    className="fill-jacarta-500 h-4 w-4 dark:fill-white"
                >
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z" />
                </svg>
            </div>
            {dropdown && (
                <div
                    className="absolute left-0 right-0 mt-2 dark:bg-jacarta-800 rounded-xl bg-white py-4 px-2 text-left shadow-xl z-50"
                >
                    <ul className="scrollbar-custom flex max-h-48 flex-col overflow-y-auto">
                        {options?.map((option, index) => (
                            <li key={index}>
                                <button
                                    className="dropdown-item font-display dark:hover:bg-jacarta-600 hover:bg-jacarta-50 flex w-full items-center justify-between rounded-xl px-5 py-2 text-left text-sm transition-colors dark:text-white"
                                    onClick={() => handleSelectChange(option)}
                                >
                                    <span className="flex items-center space-x-3">
                                        <span className="text-jacarta-700 dark:text-white">
                                            {option.label}
                                        </span>
                                    </span>
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default DynamicDropdown;
